import { ERROR_EXCEPTIONS } from '../constants/index';

export const AuthProperty = {
  Title: 'title',
  TitleTooltip: 'titleTooltip',
  Legend: 'legend',
  SubmitLabel: 'submitLabel',
  IsShowSSO: 'isShowSSO',
  IsShowNavLinks: 'isShowNavLinks',
  IsBorderedNav: 'isBorderedNav',
  IsShowError: 'isShowError',
  ErrorMessage: 'errorMessage',
  IsLoading: 'isLoading',
  FooterLinks: 'footerLinks',
};

export const AuthSlotName = {
  Error: 'error',
  NavLinks: 'navLinks',
  FooterLinks: 'footerLinks',
};

export const SubmitButtonTitle = {
  Login: 'Log In',
  SignUp: 'Sign up',
  SendRecoveryLink: 'Send Recovery Link',
  ResetPassword: 'Reset Password',
  Submit: 'Submit',
  UpdateProfile: 'Update Profile',
};

export const SSOProviders = {
  Google: 'Google',
  Facebook: 'Facebook',
  Apple: 'Apple',
};

export const SubmitButtonEventType = {
  Submit: 'submit',
};

export const AuthErrorMessages = {
  [ERROR_EXCEPTIONS.NotAuthorizedException]: 'Email or Password incorrect',
  [ERROR_EXCEPTIONS.NotResendConfirmationException]: 'Something went wrong, please try again later.',
  [ERROR_EXCEPTIONS.NotVerifiedEmailException]: 'Your haven\'t verified your email on Facebook',
  [ERROR_EXCEPTIONS.UserNotConfirmedException]: 'User is not yet confirmed.',
  [ERROR_EXCEPTIONS.LimitExceededException]: 'Attempt limit exceeded, please try again in 15 mins.',
  [ERROR_EXCEPTIONS.LimitPasswordExceededException]: 'Password attempts exceeded, please try again in 15 mins.',
  [ERROR_EXCEPTIONS.UserLambdaValidationException]: 'This domain is not allowed. Please enter a different email address.',
  [ERROR_EXCEPTIONS.CheckoutMarketDataAnalysis]: 'Check out your market data analysis in the meantime.',
  [ERROR_EXCEPTIONS.InvalidParameterException]: 'Invalid Email address format',
  [ERROR_EXCEPTIONS.UsernameExistsException]: 'An account with the given email already exists.',
  [ERROR_EXCEPTIONS.InvalidPasswordException]: 'Password did not conform with policy.',
  [ERROR_EXCEPTIONS.LoginInstead]: 'Login instead',
  [ERROR_EXCEPTIONS.CodeMismatchException]: 'That code is incorrect. Please check your email and re-enter the 6 digit number.',
};

export const AuthCustomReferrer = 'bode:auth:customState';
